import { render, staticRenderFns } from "./TheCataloguePage.vue?vue&type=template&id=5721bb3f"
import script from "./TheCataloguePage.vue?vue&type=script&lang=js"
export * from "./TheCataloguePage.vue?vue&type=script&lang=js"
import style0 from "./TheCataloguePage.vue?vue&type=style&index=0&id=5721bb3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports